<template lang="pug">
  .col-xs-12.col-sm-4.col-md-3.col-lg-3(:key="device.id")
    .device(@contextmenu="$emit('contextmenu', $event)")
      .preview-info
        .left
          button.btn.btn-default.btn-sm.text-primary(type="button" @click="$emit('refreshSs', device.id)" v-tooltip.top="$options.filters.translate('Refresh screenshot', lang)")
            i.fas.fa-camera
          div(v-if="$store.getters.hasRole(['admin', 'manager'])")
            button.btn.btn-default.btn-sm.text-info(type="button" @click="$emit('restartView', device.id)" v-tooltip.top="$options.filters.translate('Restart Chrome', lang)")
              i.fab.fa-chrome
            button.btn.btn-default.btn-sm.text-warning(type="button" @click="$emit('restartApp', device.id)" v-tooltip.top="$options.filters.translate('Restart App', lang)")
              i.fa.fa-undo
            button.btn.btn-default.btn-sm.text-danger(type="button" @click="$emit('restartDevice', device.id)" v-tooltip.top="$options.filters.translate('Restart Kiosk', lang)")
              i.fa.fa-power-off
            button.btn.btn-default.btn-sm.text-success(v-if="device.enabled && $store.getters.hasRole(['admin', 'manager']) && isEnableVersionValid(device.version)" @click="$emit('enableDevice', {'id': device.id, 'enable': false})" type="button" v-tooltip.top="$options.filters.translate('Deactivate', lang)")
              i.fa.fa-tablet-alt
            button.btn.btn-default.btn-sm.text-danger(v-if="!device.enabled && $store.getters.hasRole(['admin', 'manager']) && isEnableVersionValid(device.version)" @click="$emit('enableDevice', {'id': device.id, 'enable': true})" type="button" v-tooltip.top="$options.filters.translate('Activate', lang)")
              i.fa.fa-tablet-alt
        .right
          button.btn.btn-default.btn-sm.text-primary(v-if="$store.getters.hasRole(['admin']) && device.active" @click="$emit('generateServicePin', device)" type="button" v-tooltip.top="$options.filters.translate('Generate service pin', lang)")
            i.fa.fa-key
          button.btn.btn-default.btn-sm.text-success(v-if="$store.getters.hasRole(['admin']) && !device.active" @click="$emit('activateDevice', device)" type="button" v-tooltip.top="$options.filters.translate('Deploy', lang)")
            i.fa.fa-plane-departure
          button.btn.btn-default.btn-sm.text-warning(v-if="$store.getters.hasRole(['admin']) && device.active" @click="$emit('deactivateDevice', device)" type="button" v-tooltip.top="$options.filters.translate('Withhold', lang)")
            i.fa.fa-plane-arrival
          button.btn.btn-default.btn-sm.text-danger(v-if="$store.getters.hasRole(['admin'])" @click="$emit('removeDevice', device.id)" type="button" v-tooltip.top="$options.filters.translate('Delete', lang)")
            i.fa.fa-trash
          button.btn.btn-sm.heartbeat.disabled(type="button" :class="device.failure || device.kiosk_status | eqStatusBtn" v-tooltip.top="$options.filters.translate('Hardware status', lang) + kioskStatus")
            i.fa.fa-inverse(:class="device.failure || device.kiosk_status | eqStatusIcon")
          button.btn.btn-sm.heartbeat.disabled(type="button" :class="hbStatus" v-tooltip.top="$options.filters.translate('Pulse', lang)")
            i.fa.fa-heartbeat.fa-inverse(:class="hbStatusPulse")
      .name(data-toggle="tooltip" data-placement="bottom" v-tooltip.top="device.name + '(' + device.id + ')'")
        | {{device.name}}
        span(v-if="device.description") &nbsp;({{device.description}})
      .preview(@dblclick="openDetail" :style="{'background-image': 'url(' + screenShot + ')'}")
      .times
        .screenshot-time
          .fa.fa-camera.fa-inverse
          | &thinsp;{{device.screenshot | screenShotDateTime}}
        .time
          | {{device.hbtime | formatDateTime}}&thinsp;
          i.fa.fa-heartbeat.fa-inverse
      .device-info
        table.table.table-condensed
          tbody
            tr
              th
                i.fas.fa-shield-alt.copy(v-tooltip.top="$options.filters.translate('Wave Agent ver.', lang) + '<br>' + $options.filters.translate('Copy teleport ID', lang)" @dblclick="copyToClipboard(`kiosk-${device.localMAC.replace(/:/g, '')}`)")
              td {{device.version}}
              th
                i.fa.fa-at.copy(v-tooltip.top="'IP'" @dblclick="copyToClipboard(device.localIP)")
              td {{device.localIP}}
            tr
              th
                i.fa.fa-microchip(v-tooltip.top="$options.filters.translate('CPU usage', lang)")
              td {{device.cpuLoad | cpuFormat}}
              th
                i.fa.fa-thermometer(v-tooltip.top="$options.filters.translate('CPU Temp', lang)")
              td {{device.cpuTemp | tempFormat}}
            tr
              th
                i.fa.fa-tasks(v-tooltip.top="$options.filters.translate('Free RAM', lang)")
              td {{device.freeMem | memFormat}}
              th
                i.fas.fa-hdd(v-tooltip.top="$options.filters.translate('Disk space used', lang)")
              td {{device.diskUsagePercent}} %
</template>

<script>
import Vue from 'vue'

export default {
  name: 'device',
  props: ['lang', 'device', 'showModal'],
  data () {
    return {
      hbStatusSetInterval: undefined,
      hbStatus: undefined
    }
  },
  computed: {
    screenShot () {
      let sshotPath = '/static/no-sshot.png'
      if (this.device.screenshot && this.device.screenshot[0] && this.device.screenshot[0].filepath.length > 0) {
        sshotPath = this.device.screenshot[0].filepath
      }
      return sshotPath
    },
    hbStatusPulse () {
      if (this.hbStatus === 'btn-success') {
        return 'animated infinite pulse'
      }
      return ''
    },
    kioskStatus () {
      return Vue.filter('hwStatus')(this.device, this.lang.lang)
    }
  },
  watch: {
  },
  methods: {
    copyToClipboard (text) {
      const el = document.createElement('textarea')
      el.value = text
      document.body.appendChild(el)
      el.select()
      document.execCommand('copy')
      document.body.removeChild(el)
      this.$notify(this.$options.filters.translate('Copied to clipboard', this.lang), 'success')
    },
    isEnableVersionValid (version) {
      return true
    },
    openDetail () {
      this.$store.commit('SET_LOADER', true)
      this.$emit('openDetails', this.device)
    },
    hbStatusUpdate () {
      const self = this
      self.$data.ticker = new Date().getTime()
      if (self.device.hbtime && new Date().getTime() < self.device.hbtime + self.$store.state.config.heartbeatInterval * 2 * 1000) {
        self.$data.hbStatus = 'btn-success'
      } else {
        self.$data.hbStatus = 'btn-danger'
      }
    }
  },
  updated () {
    this.hbStatusUpdate()
  },
  created () {
    const self = this
    this.hbStatusUpdate()
    self.hbStatusSetInterval = setInterval(() => {
      self.hbStatusUpdate()
    }, 10 * 1000)
  },
  beforeDestroy () {
    clearInterval(this.hbStatusSetInterval)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/device/Device.vue